import { useSyncExternalStore } from 'react';

import type { CommunityCode } from '@/constants/communities';

/**
 * The community a switch is transitioning TO (drives the full-screen
 * CommunitySwitchOverlay), or null when idle.
 *
 * A module store rather than React state on purpose: it must survive the
 * navigation reset that remounts the app tree, it can be read without
 * subscribing (AppLayout's mount-only settle effect), and the overlay is the
 * only subscriber — so switch flips no longer rebuild the auth context and
 * re-render its ~40 consumers twice per switch.
 */
let switchingTo: CommunityCode | null = null;
const listeners = new Set<() => void>();

export function setSwitchingToCommunity(community: CommunityCode | null) {
  if (switchingTo === community) {
    return;
  }
  switchingTo = community;
  listeners.forEach((listener) => listener());
}

export function getSwitchingToCommunity() {
  return switchingTo;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useSwitchingToCommunity() {
  return useSyncExternalStore(subscribe, getSwitchingToCommunity, getSwitchingToCommunity);
}
